import { createHttpClient } from '@adapters/HttpClient';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type { ProfitabilitySummaryBreakdownQuery, ProfitabilitySummaryCogsResponse } from '../models/Profitability';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

export const useProfitabilitySummaryCogs = (query: ProfitabilitySummaryBreakdownQuery | undefined, enabled = true) => {
  return useQuery<ProfitabilitySummaryCogsResponse, Error>({
    queryKey: [
      'profitability',
      'summary-cogs',
      query?.start_date,
      query?.end_date,
      query?.date_column,
      query?.shop_id,
      query?.payment_method_id,
      query?.shipment_status_id,
      query?.page,
      query?.per_page,
    ],
    queryFn: () => adapter.getSummaryCogs(query),
    enabled: enabled && !!query?.start_date && !!query?.end_date,
    staleTime: 60 * 1000,
  });
};
